import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { AuthService } from '../../../../core/auth/services/auth.service';

@Component({
  selector: 'app-greeting-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    <div class="px-1 py-3">
      <p class="text-xs font-medium text-pmdf-muted-55 tracking-wide uppercase">
        {{ formattedDate() }} &bull; Turno {{ turno() }}
      </p>
      <h1 class="text-xl font-semibold text-pmdf-text-primary mt-1 font-family-pmdf-heading">
        {{ greeting() }}, <span class="text-pmdf-primary">{{ displayName() }}</span>
      </h1>
    </div>
  `,
})
export class GreetingHeader {
  private authService = inject(AuthService);
  private user = this.authService.user;

  displayName = computed(() => {
    const u = this.user();
    const nomeGuerra = u?.sgpol?.nomeDeGuerra;
    const raw = nomeGuerra || (u?.name || 'Policial').split(' ')[0];
    const firstName = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();

    const postoAbreviado = u?.sgpol?.posto;
    if (postoAbreviado) {
      return `${postoAbreviado.toUpperCase()} ${firstName}`;
    }

    const titleParts = (u?.title || '').split(' ').filter(Boolean);
    let title: string | null = null;
    if (titleParts.length > 0) {
      const startsWithOrdinal = /^\d+[ºª]$/.test(titleParts[0]);
      const rawTitle = startsWithOrdinal && titleParts.length > 1
        ? `${titleParts[0]} ${titleParts[1]}`
        : titleParts[0];
      title = rawTitle
        .split(' ')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
    }

    return title ? `${title} ${firstName}` : firstName;
  });

  greeting = computed(() => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Bom dia';
    if (hour < 18) return 'Boa tarde';
    return 'Boa noite';
  });

  turno = computed(() => {
    const hour = new Date().getHours();
    return hour >= 6 && hour < 18 ? 'Diurno' : 'Noturno';
  });

  formattedDate = computed(() => {
    const now = new Date();
    const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
    const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    return `${days[now.getDay()]}, ${String(now.getDate()).padStart(2, '0')} de ${months[now.getMonth()]}`;
  });
}
